export default function toggleButton({ variables, }) {
    return {
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontSize: variables.type_body_sm_font_size,
                    fontWeight: variables.font_weight_medium,
                    color: variables.text_primary,
                    border: `1px solid ${variables.border_strong}`,
                    borderRadius: variables.border_radius_small,
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                    "&.Mui-selected": {
                        backgroundColor: variables.surface_selected,
                        color: variables.interactive_selected,
                        "&:hover": {
                            backgroundColor: variables.surface_selected_hover,
                        },
                    },
                },
                sizeSmall: {
                    height: variables.component_height_small,
                    padding: `${variables.spacing_02} ${variables.spacing_03}`,
                },
                sizeMedium: {
                    height: variables.component_height_medium,
                },
                sizeLarge: {
                    height: variables.component_height_large,
                },
            },
        },
        MuiToggleButtonGroup: {
            styleOverrides: {
                grouped: {
                    border: `1px solid ${variables.border_strong}`,
                },
            },
        },
    };
}
//# sourceMappingURL=toggleButton.js.map